'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLiveChatAttachments = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLiveChatAttachments = exports.getLiveChatAttachments = (0, _getIn2.default)(_keyPaths.LIVE_CHAT_ATTACHMENTS);